// extracted by mini-css-extract-plugin
export default {"content":"TG-z","lookName":"UG-z","shopTheLookContainer":"VG-z","productContainer":"WG-z","imageContainer":"XG-z","mainImage":"YG-z"};